var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTripleDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29675 10.5C4.19218 10.5 3.29675 11.3954 3.29675 12.5C3.29675 13.6046 4.19218 14.5 5.29675 14.5C6.40132 14.5 7.29675 13.6046 7.29675 12.5C7.29675 11.3954 6.40132 10.5 5.29675 10.5ZM12.2968 10.5C11.1922 10.5 10.2968 11.3954 10.2968 12.5C10.2968 13.6046 11.1922 14.5 12.2968 14.5C13.4014 14.5 14.2968 13.6046 14.2968 12.5C14.2968 11.3954 13.4014 10.5 12.2968 10.5ZM17.2968 12.5C17.2968 11.3954 18.1922 10.5 19.2968 10.5C20.4014 10.5 21.2968 11.3954 21.2968 12.5C21.2968 13.6046 20.4014 14.5 19.2968 14.5C18.1922 14.5 17.2968 13.6046 17.2968 12.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripleDots);
export default __webpack_public_path__ + "static/media/triple_dots.893c7868d7ca3ced718625f8a6e70c55.svg";
export { ForwardRef as ReactComponent };